<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-26 11:58:55
!-->
<template>
  <div id="commodities" class="commodities">
    <div class="main-info p24 check-price-form">
      <el-form
        ref="formData"
        :model="formData"
        :rules="allRules"
        label-position="top"
        size="medium"
        class="item-Surcharge"
        @submit.native.prevent
      >
        <div class="new_inquiry_header item-Surcharge_search">
          <el-form-item class="flex-width_1" prop="nameCh" label="商品名称（中文）" label-width="48%">
            <el-input v-model="formData.nameCh" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="nameEn" label="商品名称（英文）" label-width="48%">
            <el-input v-model="formData.nameEn" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="brand" label="品牌" label-width="48%">
            <el-input v-model="formData.brand" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="model" label="型号" label-width="48%">
            <el-input v-model="formData.model" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="customlabel" label="目的国海关编码" label-width="48%">
            <el-input v-model="formData.customlabel" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="skuId" label="SKU" label-width="48%">
            <el-input v-model="formData.skuId" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="materialCh" label="材质" label-width="48%" >
            <el-input v-model="formData.materialCh" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="purposeCh" label="用途" label-width="48%">
            <el-input v-model="formData.purposeCh" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="unitPrice" label="单个商品申报金额（美金）" label-width="48%">
            <el-input v-model="formData.unitPrice" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="originCountryName" label="原产地" label-width="48%" >
            <el-select v-model="formData.originCountryName" popper-class="cargo_info_select" filterable>
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :value="item.id"
                :label="item.code+'-'+item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item class="flex-width_1" prop="" label="货物类型">
            <div class="flex">
              <div style="align-items: center;display: flex;">
                <el-switch v-model="formData.isBattery" :inactive-value="0" :active-value="1" ></el-switch>
                <span class="margin-left_8">带电</span>
              </div>
              <div style="align-items: center;display: flex;">
                <el-switch class="margin-left_20" v-model="formData.isMagnetic" :inactive-value="0" :active-value="1"></el-switch>
                <span class="margin-left_8">带磁</span>
              </div>
              <div style="align-items: center;display: flex;">
                <el-switch class="margin-left_20" v-model="formData.isDanger" :inactive-value="0" :active-value="1" ></el-switch>
                <span class="margin-left_8">危险品</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="flex-width_1" prop="saleUrl" label="商品链接" >
            <el-input v-model="formData.saleUrl" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="productImage" label="商品图片" >
            <el-upload 
              list-type="picture-card"
              class="upload-img"
              :class="{uploadDisabled:fileImgList.length > 0 }"
              ref="upload"
              :action="define.comUrl + '/api/file/Uploader/TemporaryFile'"  
              :data="{}"
              :before-upload="handleBeforeUpload"
              :on-preview="imgHandlePictureCardPreview"
              :on-remove = "imgHandleOnRemove"
              :on-success="(response, file, fileList) => handleSuccessImg(response, file, fileList)"
              :multiple="false"
              :limit="1"
              :file-list="fileImgList"
              accept=".jpg,.jpeg,.png,.bmp,.gif">
                <div class="upload-icon">
                  <i class="el-icon-plus"></i>
                  <div style="line-height: 20px;">点击上传</div>
                </div>
                <div slot="tip" class="el-upload__tip upload-notes">说明：文件大小不超过7MB</div>
            </el-upload>
            <el-dialog :visible.sync="imgDialogVisible" :append-to-body="true">
              <img width="100%" :src="imgDialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item class="flex-width_1" prop="productFile" label="商品文件" >
              <div class="custom-file-list" v-if="fileList.length > 0">
                <div class="file-card" v-for="(file, index) in fileList" :key="index">
                  <div class="file-icon">
                    <i :class="getFileIcon(file.name)"></i>
                  </div>
                  <div class="file-info">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-size">{{ formatSize(file.size) }}</div>
                  </div>
                  <el-button size="mini" type="danger" @click="fileHandleOnRemove(file)">删除</el-button>
                </div>
              </div>
             <el-upload 
              class="upload-file"
              :class="{uploadDisabled:fileList.length > 0 }"
              list-type="picture-card"
              ref="upload"
              :action="define.comUrl + '/api/file/Uploader/TemporaryFile'"  
              :data="{}"
              :before-upload="handleBeforeUpload"
              :on-remove = "fileHandleOnRemove"
              :on-success="(response, file, fileList) => handleSuccessFile(response, file, fileList)"
              :multiple="false"
              :file-list="fileList"
              :show-file-list="false"
              :limit="1">
                <div class="upload-icon" >
                  <i class="el-icon-plus"></i>
                  <div style="line-height: 20px;">点击上传</div>
                </div>
                <div slot="tip" class="el-upload__tip upload-notes">说明：文件大小不超过7MB</div>
            </el-upload>


          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="foot-button-manage">
        <div>
          <el-button  @click="clickCancel">取消</el-button>
          <el-button  type="primary"  :loading="btnLoading" @click="clickSave">确定</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import {
	  GetCountry
} from '../../../api/base.js'
import request from '@/utils/request'
import define from '@/utils/define'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    // 组件的引用
  },
  props: {
    isEmitData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var checkEmpty = (rule, value, callback) => {
      if (rule.required === false) {
        callback()
        return false
      }
      if (!value) {
        if (rule.fullField == 'StartCityKey') {
          this.isCol1 = true
        } else {
          this.isCol1 = false
        }

        document.documentElement.scrollTop = 0
        return callback(new Error('请输入'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        id: '',
        nameCh: '',
        nameEn: '',
        brand: '',
        model: '',
        originCountryName: '459155081518907794',
        customlabel: '',
        skuId: '',
        materialCh: '',
        purposeCh: '',
        unitPrice: '',
        unitPrice: '',
        isBattery: 0,
        isMagnetic: 0,
        isDanger: 0,
        saleUrl: '',
        productImage: '',
        pictureUrl:'',
        productFile: ''
      },
      allRules: {
        nameCh: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        nameEn: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        brand: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        model: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        customlabel: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        materialCh: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        purposeCh: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        unitPrice: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        originCountryName: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        productImage:[{
          required: true,
          validator: this.validateImage,
          trigger: 'change'
        }]
      },
      countryList: [],
      imgDialogVisible: false,
      imgDialogImageUrl: '',
      fileImgList:[],
      fileList:[],
      token: '',
      visible: false,
      btnLoading: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getCountry()
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    validateImage(rule, value, callback){
      if (value) {
        callback();
        return;
      }
      if (!this.productImage || !(this.fileImgList?.length > 0)) {
        callback(new Error('请上传商品图片'));
      }
    },
    getFileIcon(fileName) {
      const ext = fileName.split('.').pop().toLowerCase();
      const fileIcons = {
        doc: 'el-icon-document',
        docx: 'el-icon-document',
        pdf: 'el-icon-document-pdf',
        xls: 'el-icon-document-excel',
        xlsx: 'el-icon-document-excel',
        ppt: 'el-icon-document',
        pptx: 'el-icon-document',
        zip: 'el-icon-document-zip',
        rar: 'el-icon-document-zip',
        jpg: 'el-icon-picture',
        jpeg: 'el-icon-picture',
        png: 'el-icon-picture',
        gif: 'el-icon-picture',
        default: 'el-icon-document'
      };
      return fileIcons[ext] || fileIcons.default;
    },
    formatSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    // 限制文件上传的大小
    handleBeforeUpload(file) {
          
    },
    imgHandleOnRemove(file, fileList){
      this.fileImgList = fileList
      this.formData.productImage = ''
    },
    fileHandleOnRemove(file){
       const index = this.fileList.indexOf(file);
        if (index !== -1) {
          this.fileList.splice(index, 1);
        }
    },
    // 上传成功
    handleSuccessImg(response, file, fileList) {
      this.fileImgList = fileList
      var imgInfo = [
        {
          fileId : file.response.data.url.split('/').pop(),
          name : file.name,
          size : file.size,
          url : file.response.data.url
        }
      ]
      this.formData.pictureUrl  = fileList[0].response.data.url
      this.formData.productImage = JSON.stringify(imgInfo)
    },
    handleSuccessFile(response, file, fileList) {
      this.fileList = fileList;
      var fileInfo = [
        {
          fileId : file.response.data.url.split('/').pop(),
          name : file.name,
          size : file.size,
          url : file.response.data.url
        }
      ]
      this.formData.productFile = JSON.stringify(fileInfo)
    },
    imgHandlePictureCardPreview(file){
      this.imgDialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    getCountry() {
      GetCountry().then(res => {
			    this.countryList = res.data
			  })
    },
    init(id) {
      this.formData.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['formData'].resetFields()
        if (this.formData.id) {
          request({
            url: '/api/Wms/OrderCargo/GetCustomerCargo/' + this.formData.id,
            method: 'get',
            headers: {
              Authorization: this.token
            }
          }).then(res => {
            this.formData = res.data
            if( res.data.productImage){
              this.fileImgList.push({
                url:define.comUrl + res.data.pictureUrl
              })
            }
            if(res.data.productFile){
              this.fileList.push(...JSON.parse(res.data.productFile))
            }
          })
        }
      })
    },
    clickSave() {
      // 表单校验
      this.$refs['formData'].validate((val) => {
        if (val) {
          this.btnLoading = true
          if (!this.formData.id) {
            request({
              url: `/api/Wms/OrderCargo/InsertCustomerCargo`,
              method: 'post',
              data: this.formData,
              headers: {
                Authorization: this.token
              }
            }).then((res) => {
              if(this.isEmitData){
                this.$emit('save', this.formData);
              }
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.btnLoading = false
                  this.clickCancel()
                  this.$emit('refresh', true)
                }
              })
            }).finally(() => {
              this.btnLoading = false
            })
          } else {
            request({
              url: '/api/Wms/OrderCargo/UpdateCustomerCargo/' + this.formData.id,
              method: 'PUT',
              data: this.formData,
              headers: {
                Authorization: this.token
              }
            }).then((res) => {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.btnLoading = false
                  this.clickCancel()
                  this.$emit('refresh', true)
                }
              })
            }).finally(() => {
              this.btnLoading = false
            })
          }
        }
      })
    },
    clickCancel() {
      this.$emit('close', false)
    }
  }
}
</script>
<style scoped lang='scss'>
	.commodities {
		height: auto;
		background: #ffffff;
		border-radius: 8px;

		.new_inquiry_header {
			width: auto;
			display: flex;
			flex-wrap: wrap;

		}
	}
  
	.item-Surcharge {
		width: 100%;
		background: #fff;
		border-radius: 8px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;

		.item-Surcharge_search {
			display: flex;
			flex-wrap: wrap;
			width: auto;
			justify-content: space-between;
      
      ::v-deep .el-upload--picture-card{
        width: 106px;
        height: 106px;
      }

      .upload-icon{
        display: flex;
        height: 100%;
        color: #8B8B8B;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }

      .upload-notes{
        font-size: 14px;
        color: #AEAEAF;
        text-align: left;
        font-style: normal;
      }

      ::v-deep .el-form-item{
        margin: 5px 0;
      }

      ::v-deep .el-upload-list__item{
        width: 106px;
        height: 106px;
      }

      .uploadDisabled {
        ::v-deep .el-upload--picture-card{
          display: none;
        }
      }

      .custom-file-list {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-top: 15px;
      }
      .file-card {
        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        width: 300px;
      }
      .file-icon {
        width: 40px;
        height: 40px;
        background-color: #f5f7fa;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
      }
      .file-icon i {
        font-size: 20px;
        color: #909399;
      }
      .file-info {
        flex: 1;
        min-width: 0;
      }
      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 500;
      }
      .file-size {
        font-size: 12px;
        color: #909399;
      }





			.search-flex-item {
				display: flex;
				align-items: baseline;
				margin-right: 16px;
			}

			.search-type {
				width: calc(100% - 65px);

				& ::v-deep .el-input__inner {
					height: 32px !important;
					line-height: 32px !important;
				}

				& ::v-deep .el-select__caret {
					line-height: 32px !important;
				}
			}

			.mr6 {
				margin-right: 6px;
			}

			.search-label {
				width: 80px;
				display: block;
				font-size: 13px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 18px;
			}

			.reset-radio-group {
				border-radius: 4px;

				& ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
					background: rgba(0, 70, 185, 0.04);
					border-color: #0046b9;
					color: #0046b9;
					box-sizing: border-box;
				}

				& ::v-deep .el-radio-button__inner {
					display: inline-block;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #777;

					&:hover {
						color: #0046b9;
					}
				}

				& ::v-deep .el-radio-button--small .el-radio-button__inner {
					padding: 8px 16px;
				}
			}

			.search-left {
				flex: 1;
			}
		}
	}

	.el-select {
		width: 100%;
	}

	.el-form-item--medium {
		width: 48%;
		float: left;
		text-align: left;

		.el-form-item__label {
			line-height: 8px !important;
			padding: 0px 0px 7px 0 !important;
			margin-top: 18px !important;
		}

		.input-Lowest {
			display: flex;

			.el-radio-group {
				width: 120px;
			}

			.el-input__inner {
				width: 60px;
				margin-left: 12px;
			}

			.el-input {
				width: 60px !important;
			}
		}

		.el-radio-group {
			display: flex;
			margin-top: 8px;

			label:nth-of-type(1) {
				margin-right: 20px !important;
			}

			label:nth-of-type(3) {
				margin-left: 10px !important;
			}
		}

		.el-radio__input.is-checked .el-radio__inner {
			border-color: #0046b9;
			background: #0046b9;
		}

		.el-radio__input.is-checked+.el-radio__label {
			color: #0046b9;
		}

		.el-input {
			.el-input__inner {
				border-radius: 4px;
				border: 1px solid #dcdcdc;
				height: 40px;
				line-height: 32px;
				padding-left: 8px;
				font-size: 13px;
				font-family: "PingFangSC-Regular", "Microsoft YaHei", sans-serif;
				font-weight: 500;
				color: #333333;

				&:hover {
					border: 1px solid #999999;
				}

				&:focus {
					border: 1px solid #0046b9;
				}
			}
		}
	}

	.upload-class {
		height: 72px;
		background: rgba(153, 153, 153, 0.06);
		border-radius: 8px;
		border: 1px dashed rgba(153, 153, 153, 0.56);
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;

		.upload-label {
			flex: 1;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;

			span:nth-of-type(1) {
				color: #333333;
			}

			span:nth-of-type(2) {
				color: #aaaaaa;
			}
		}

		img:nth-of-type(1) {
			margin: 24px 16px 24px 24px;
		}
	}

	.foot-button-manage {
		font-size: 16px;
		margin-top: 33px;
    text-align: right;
    position: absolute;
    bottom: 20px;
    right: 20px;

		button {
			width: 100px;
			height: 38x;
      border-radius: 4px;
		}
	}
</style>
